import React from 'react';
import { Check, ShieldCheck, Download, Printer, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const OfertaFinal: React.FC = () => {
  return <section className="py-10 px-4 bg-violet text-cream relative overflow-hidden" data-id="element-96">
      <div className="max-w-2xl mx-auto relative z-10" data-id="element-97">
        <div className="text-center mb-6" data-id="element-98">
          <span className="inline-block bg-brandred text-white font-rounded font-bold uppercase tracking-widest text-xs px-4 py-1.5 rounded-full mb-4 shadow-md" data-id="element-99">
            🔥 OFERTA POR TIEMPO LIMITADO
          </span>
          <h2 className="font-rounded font-bold text-[2.25rem] sm:text-5xl text-cream leading-[1.02] mb-3" data-id="element-100">
            Toda la magia Disney en un{' '}
            <span className="text-yellow" data-id="element-101">solo lugar</span>
          </h2>
          <p className="text-cream/85 text-base sm:text-lg font-semibold max-w-xl mx-auto" data-id="element-102">
            Más de 50 libros y 2.500 páginas listas para imprimir y disfrutar
            desde hoy.
          </p>
        </div>

        <div className="mb-6" data-id="element-103">
          <img src="https://cdn.magicpatterns.com/uploads/d4RRdDi26Um4PeNDBwU8ao/colecion_completa.png" alt="Biblioteca Mágica Disney" className="w-full h-auto max-w-md mx-auto drop-shadow-2xl" data-id="element-104" />
        </div>

        <div className="bg-cream text-violet p-6 sm:p-8 rounded-3xl shadow-2xl border-4 border-yellow relative" data-id="element-105">
          <div className="flex justify-center gap-0.5 mb-3" data-id="element-106">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-dark text-gold-dark" data-id="element-107" />)}
          </div>

          <div className="text-center mb-5" data-id="element-108">
            <p className="text-sm text-textsoft font-bold uppercase tracking-wider mb-1" data-id="element-109">
              Precio especial hoy
            </p>
            <div className="flex items-baseline justify-center gap-3" data-id="element-110">
              <span className="text-gray-400 line-through text-xl font-bold" data-id="element-111">
                $39.990
              </span>
              <span className="font-rounded font-bold text-6xl sm:text-7xl text-violet leading-none" data-id="element-112">
                $19.990
              </span>
            </div>
            <p className="text-sm font-bold text-brandgreen mt-1" data-id="element-113">
              Ahorras $20.000 (50% OFF)
            </p>
          </div>

          <ul className="space-y-2 mb-6 max-w-xs mx-auto" data-id="element-114">
            {['Acceso inmediato', 'Descarga digital', 'Más de 50 libros', 'Más de 2.500 páginas', 'Listo para imprimir'].map((item, idx) => <li key={idx} className="flex items-center gap-2.5 text-violet font-bold text-base" data-id="element-115">
                <div className="bg-brandgreen rounded-full p-0.5 flex-shrink-0" data-id="element-116">
                  <Check className="text-white w-3.5 h-3.5" strokeWidth={3.5} data-id="element-117" />
                </div>
                <span data-id="element-118">{item}</span>
              </li>)}
          </ul>

          <CTAButton size="large" data-id="element-119" />

          <div className="flex flex-wrap justify-center gap-4 mt-5 pt-5 border-t-2 border-dashed border-cream-dark text-xs sm:text-sm font-bold text-textsoft" data-id="element-120">
            <div className="flex items-center gap-1.5" data-id="element-121">
              <ShieldCheck className="w-4 h-4 text-brandgreen" data-id="element-122" />
              <span data-id="element-123">Compra segura</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-124">
              <Download className="w-4 h-4 text-violet" data-id="element-125" />
              <span data-id="element-126">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-127">
              <Printer className="w-4 h-4 text-violet" data-id="element-128" />
              <span data-id="element-129">Imprime sin límites</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};